import * as React from "react";

const Number = (props: any) => (
  <svg width={20} height={20} viewBox="0 0 20 20" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <path
        d="M9.36 9.108l-.288 1.984h1.552l.272-1.984H9.36zm-2.032 3.424H6v-1.44h1.52l.288-1.984H6.48v-1.44H8L8.448 4.5H10l-.448 3.168h1.552l.432-3.168h1.552l-.432 3.168h1.184v1.44h-1.392l-.272 1.984h1.184v1.44h-1.392l-.432 3.168H9.984l.432-3.168H8.88L8.432 15.7H6.88l.448-3.168z"
        fill="#7B838C"
      />
    </g>
  </svg>
);

export default Number;

